// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_house,
  add_house,
  update_house,
  delete_house,
  get_house_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  houses: [],
  houselist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
  },
};

// Async Thunks for API Calls
export const fetchHouseList = createAsyncThunk(
    'house/fetchHouselist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_house_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  

// Async Thunks for API Calls
export const fetchHouse = createAsyncThunk(
  "house/fetchHouse",
  async ({ page, page_size,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_house(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createHouse = createAsyncThunk(
  "house/createHouse",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_house(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateHouse = createAsyncThunk(
  "house/updateHouse",
  async ({ data, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await update_house(data, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteHouse = createAsyncThunk(
  "house/deleteHouse",
  async ({ ids, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_house({ ids }, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const houseSlice = createSlice({
  name: 'houses',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, name,house_code,description } = action.payload;
      state.formData = { id, name,house_code,description };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        house_code:"",
        description:""
      };
    },
    setHouse(state, action) {
      state.houses = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchHouseList.fulfilled, (state, action) => {
        state.houselist = action.payload.data;
      })
      .addCase(fetchHouseList.rejected, (state, action) => {
        state.houselist = [];
      })
       // Fetch Classes
       .addCase(fetchHouse.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHouse.fulfilled, (state, action) => {
        state.loading = false;
        state.houses = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchHouse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(createHouse.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createHouse.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createHouse.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateHouse.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateHouse.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateHouse.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete Class
      .addCase(deleteHouse.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteHouse.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteHouse.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setHouse,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = houseSlice.actions;
export default houseSlice.reducer;
